<div #container [ngClass]="{'p-sidebar':true, 'p-sidebar-active': visible,
'p-sidebar-left': (position === 'left'), 'p-sidebar-right': (position === 'right'),
'p-sidebar-top': (position === 'top'), 'p-sidebar-bottom': (position === 'bottom'),
'p-sidebar-full': fullScreen}"
[@panelState]="visible ? 'visible' : 'hidden'" (@panelState.start)="onAnimationStart($event)" [ngStyle]="style" [class]="styleClass"  role="complementary" [attr.aria-modal]="modal">
<div class="p-sidebar-content">
    <button type="button" class="p-sidebar-close p-link" *ngIf="showCloseIcon" (click)="close($event)" (keydown.enter)="close($event)" [attr.aria-label]="ariaCloseLabel" matRipple [matRippleUnbounded]="true">
        <span class="p-sidebar-close-icon pi pi-times"></span>
    </button>
    <ng-content></ng-content>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
</div>
